// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"ca4cb808","425":"51ee6229","510":"1f0e6924","532":"414d80e7","633":"f94f344a","634":"a2f765be","922":"23692b4c","937":"333787ea","972":"acd8a6a6"}[chunkId] + ".chunk.js";
};